// extracted by mini-css-extract-plugin
module.exports = {"moneyBack":"money-back_moneyBack__8E2Fb","moneyBackBold":"money-back_moneyBackBold__wJTWz","moneyBackPV24":"money-back_moneyBackPV24__pCgxB"};